import Cookies from 'js-cookie'

class CookieNotice {
  constructor() {
    this.init = this.init.bind(this);
    this.init();
  }

  init() {
    const cookieBanner = document.querySelector('[data-cookie-notice]');
    const cookieBannerClose = document.querySelector('[data-cookie-accept]');

    if (cookieBanner && cookieBannerClose) {
      if (Cookies.get('cookie_accept') === undefined) {
        cookieBannerClose.addEventListener('click', function () {
          Cookies.set('cookie_accept', 'cookies accepted', { expires: 365, path: '/' });
          cookieBanner.classList.add('cookie-notice--fade-out');

          cookieBanner.addEventListener('transitionend', () => {
            cookieBanner.remove();
          });
        });
      } else {
        // Remove cookie notice to prevent it from being displayed even if notice was accepted
        cookieBanner.remove();
      }
    }
  }
}

export default new CookieNotice();
